export default __webpack_public_path__ + "static/media/Formular-Medium.5d7899cb.woff";